import React, { useContext, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import {
  LOGIN_ROUTE,
  MAIN_ROUTE,
  REPORT_ROUTE,
  CONTRACTS_ROUTE,
  UPLOAD_ROUTE,
  USERS_ROUTE,
  TRACKS_ROUTE
} from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const pages = [
  // { name: "Пользователи", href: USERS_ROUTE },
  // { name: "Данные", href: MAIN_ROUTE },
  // { name: "Договоры", href: CONTRACTS_ROUTE },
  // { name: "Загрузить документ", href: UPLOAD_ROUTE },
];
const settings = ["Выйти"];

const NavBar = observer(() => {
  const { user } = useContext(Context);
  // const usadm = user.getIsAdmin();
  const [admin, setAdmin] = React.useState(false);
  const [userLevel, setUserLevel] = React.useState(false);
  const [token, setToken] = React.useState(localStorage.getItem("token") || "");

  useEffect(() => {
    const getUsadm = () => {
      try {
        const tkn = jwtDecode(token);
        if (tkn.role === "ADMIN") setAdmin(true);
      } catch (e) {
        console.log(e);
      }
    };
    getUsadm();
  }, []);

  useEffect(() => {
    const getUsadm = () => {
      try {
        const tkn = jwtDecode(token);
        console.log("token", tkn);
        if (tkn.role === "ADMIN" || tkn.role === "USER") setUserLevel(true);
      } catch (e) {
        console.log(e);
      }
    };
    getUsadm();
  }, []);

  const navigate = useNavigate();

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      {userLevel && (
        <AppBar position="static">
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              {/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}
              <Typography
                onClick={() => navigate(MAIN_ROUTE)}
                variant="h6"
                noWrap
                component="a"
                style={{ cursor: "pointer" }}
                sx={{
                  mr: 2,
                  display: { xs: "none", md: "flex" },
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                RADIORECORD
              </Typography>

              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  {pages.map((page) => (
                    <MenuItem key={page.name}>
                      <Typography
                        textAlign="center"
                        onClick={() => navigate(page.href)}
                      >
                        {page.name}
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
              {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
              <Typography
                variant="h5"
                noWrap
                component="a"
                sx={{
                  mr: 2,
                  display: { xs: "flex", md: "none" },
                  flexGrow: 1,
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                RADIORECORD
              </Typography>

              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                {userLevel === true && (
                  <Button
                    key="users"
                    onClick={() => navigate(USERS_ROUTE)}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    Пользователи
                  </Button>
                )}
                {userLevel === true && (
                  <Button
                    key="contracts"
                    onClick={() => navigate(CONTRACTS_ROUTE)}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    Договоры
                  </Button>
                )}
                {userLevel === true && (
                  <Button
                    key="upload"
                    onClick={() => navigate(UPLOAD_ROUTE)}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    Загрузки
                  </Button>
                )}
                {userLevel === true && (
                  <Button
                    key="upload"
                    onClick={() => navigate(TRACKS_ROUTE)}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    Треки
                  </Button>
                )}
                {pages.map((page) => (
                  <Button
                    key={page.name}
                    onClick={() => navigate(page.href)}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    {page.name}
                  </Button>
                ))}
              </Box>

              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      alt="Remy Sharp"
                      src="/static/images/avatar/2.jpg"
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting) => (
                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                      <Typography
                        onClick={() => {
                          setToken("");
                          user.setIsAuth(false);
                          return navigate(LOGIN_ROUTE);
                        }}
                        textAlign="center"
                      >
                        {setting}
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )}
    </>
  );
});

export default NavBar;
